'use client';

var errorMsgs = function (translate) {
    if (translate) {
        return {
            required: translate('This field is required.'),
            email: translate('This is not a valid email address.'),
            number: '',
            'no-number-email': translate('Please do not enter phone number or email.'),
            url: translate('This is not a valid URL.'),
            'no-special-chars': translate('Please do not enter numbers or special characters.'),
            'no-special-chars-without-number': translate('Please do not enter special characters.'),
            'vn-phone-number': translate('The phone number format is invalid.'),
            'international-phone-number': translate('The phone number format is invalid.'),
            'no-special-chars-for-job-title': translate('Please do not enter special characters.')
        };
    }
    return {
        required: 'This field is required.',
        email: 'This is not a valid email address.',
        number: '',
        'no-number-email': 'Please do not enter phone number or email.',
        url: 'This is not a valid URL.',
        'no-special-chars': 'Please do not enter numbers or special characters.',
        'no-special-chars-without-number': 'Please do not enter special characters.',
        'vn-phone-number': 'The phone number format is invalid.',
        'international-phone-number': 'The phone number format is invalid.',
        'no-special-chars-for-job-title': 'Please do not enter special characters.'
    };
};

export { errorMsgs };
//# sourceMappingURL=constants.js.map
